import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  headerPlaceholder: {
    id: 'learn.header.h2.placeholder',
    defaultMessage: 'Level 2 headings may be created by course providers in the future.',
    description: 'Message spoken by a screenreader indicating that the h2 tag is a placeholder.',
  },
  loadFailure: {
    id: 'learn.course.load.failure',
    defaultMessage: 'There was an error loading this course.',
    description: 'Message when a course fails to load',
  },
  loadingHonorCode: {
    id: 'learn.loading.honor.codk',
    defaultMessage: 'Loading honor code messaging...',
    description: 'Message shown when an interface about the honor code is being loaded',
  },
  loadingLockedContent: {
    id: 'learn.loading.content.lock',
    defaultMessage: 'Loading locked content messaging...',
    description: 'Message shown when an interface about locked content is being loaded',
  },
  loadingSequence: {
    id: 'learn.loading.learning.sequence',
    defaultMessage: 'Loading learning sequence...',
    description: 'Message when learning sequence is being loaded',
  },
  noContent: {
    id: 'learn.sequence.no.content',
    defaultMessage: 'There is no content here.',
    description: 'Message shown when there is no content to show a user inside a learning sequence.',
  },
  loadingElectives: {
    id: 'learn.loading.electives',
    defaultMessage: 'Loading electives...',
    description: 'Message when electives is being loaded',
  },
  electiveTitle: {
    id: 'learn.elective.title',
    defaultMessage: 'Select Your Elective Projects',
    description: 'Elective title',
  },
  electiveMinReqTitle: {
    id: 'learn.elective.minReqElectiveTitle',
    defaultMessage: 'Minimum of {minReqElectives} Required {minReqElectivesNumber, plural, one {Project} other {Projects}}',
    description: 'Minimum required electives title displayed under elective title',
  },
  electiveDescriptionMinReqElective: {
    id: 'learn.elective.description.minReqElective',
    defaultMessage: 'Choose at least {minReqElectives} project{isMultipleProjects} as required for this level. Selected elective projects can be accessed from the project menu.',
    description: 'Elective description shown when min req elevtive is present',
  },
  electiveDescriptionNoMinReqElective: {
    id: 'learn.elective.description.no.minReqElective',
    defaultMessage: 'You can select any electives displayed below to be displayed on your final transcript.',
    description: 'Elective description shown when min req elevtive is not present',
  },
  electiveFormSubmitText: {
    id: 'learn.elective.submit.text',
    defaultMessage: 'Submit',
    description: 'Button text sown on elective form submission',
  },
  electiveFormSubmitToolTip: {
    id: 'learn.elective.submit.tooltip.text',
    defaultMessage: 'Please select minimum electives.',
    description: 'Tooltip text sown on elective form submission submit button',
  },
  electiveFormSubmitConfirmationText: {
    id: 'learn.elective.submit.confirmation.modal.text',
    defaultMessage: 'You are about to unselect an elective that is currently in progress, please note that you will lose all your progress for the unselected elective if you do so.',
    description: 'Elective form submission confirmation modal text',
  },
  unitRemoved: {
    id: 'learn.unit.removed',
    defaultMessage: 'This Unit has been removed. Please click the button below to refresh the page.',
    description: 'Message shown when loading removed unit',
  },
  unitRemovedTryAgainText: {
    id: 'learn.unit.removed.try.again.text',
    defaultMessage: 'Try again',
    description: 'Message shown unit refresh button',
  },
  electiveDialogClose: {
    id: 'learn.elective.dialog.close.text',
    defaultMessage: 'Close',
    description: 'Elective Details close modal button text',
  },
  electiveDialogCompleted: {
    id: 'learn.elective.dialog.update.complete.text',
    defaultMessage: 'Completed',
    description: 'Elective Details completed modal button text',
  },
  electiveDialogUnSelect: {
    id: 'learn.elective.dialog.update.unselect.text',
    defaultMessage: 'Unselect',
    description: 'Elective Details unselect modal button text',
  },
  electiveDialogSelect: {
    id: 'learn.elective.dialog.update.select.text',
    defaultMessage: 'Select',
    description: 'Elective Details select modal button text',
  },
  electiveDialogInProgress: {
    id: 'learn.elective.dialog.update.inprogress.text',
    defaultMessage: 'In Progress',
    description: 'Elective Details In progress status',
  },
  electiveSelected: {
    id: 'learn.elective.status.selected.text',
    defaultMessage: 'Selected',
    description: 'Elective Details selected status',
  },
  electiveNotSelected: {
    id: 'learn.elective.status.not.elected.text',
    defaultMessage: 'Not Selected',
    description: 'Elective Details not selected status',
  },
  electiveAriaSubmit: {
    id: 'learn.elective.status.aria.submitting',
    defaultMessage: 'Submitting',
    description: 'Electives are submitting',
  },
  electiveAriaSave: {
    id: 'learn.elective.status.aria.save',
    defaultMessage: 'Electives saved successfully',
    description: 'Electives are saved',
  },
  electiveMinReqElectivesCompleted: {
    id: 'learn.elective.minReqElectivesCompleted',
    defaultMessage: '{totalCompletedElectives} of {minReqElectives} Completed',
    description: 'heading shown after cards to show the number of electives completed when minReqElectives is not zero',
  },
  electiveNoMinReqElectivesCompleted: {
    id: 'learn.elective.noMinReqElectivesCompleted',
    defaultMessage: '{totalCompletedElectives} Completed',
    description: 'heading shown after cards to show the number of electives completed when minReqElectives is not zero',
  },
  electiveAfterSubmitDialogTitle: {
    id: 'learn.elective.afterSubmit.dialog.title',
    defaultMessage: 'Electives Selected',
    description: 'Elective after submit dialog title',
  },
  electiveAfterSubmitDialogDescription: {
    id: 'learn.elective.afterSubmit.dialog.description',
    defaultMessage: 'You have selected {totalSelectedElectives} of {minReqElectives} elective {minReqElectivesNumber, plural, one {Project} other {Projects}} required for this level. Selected elective projects can be accessed from the project menu.',
    description: 'Elective after submit dialog description',
  },
});

export default messages;
